export default __webpack_public_path__ + "static/media/ypi.3351261a.png";